var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29158 14.2071C8.10477 14.0182 8 13.7632 8 13.4976C8 13.2319 8.10477 12.977 8.29158 12.7881L11.2306 9.82306C11.4486 9.60806 11.7306 9.50106 12.0096 9.50106C12.2886 9.50106 12.5656 9.60806 12.7786 9.82306L15.7086 12.7781C15.8951 12.9671 15.9998 13.222 15.9998 13.4876C15.9998 13.7531 15.8951 14.008 15.7086 14.1971C15.6167 14.2902 15.5073 14.3642 15.3866 14.4147C15.2659 14.4653 15.1364 14.4913 15.0056 14.4913C14.8748 14.4913 14.7452 14.4653 14.6245 14.4147C14.5039 14.3642 14.3944 14.2902 14.3026 14.1971L12.0046 11.8801L9.69758 14.2071C9.60554 14.2999 9.49604 14.3736 9.37538 14.4238C9.25472 14.4741 9.1253 14.5 8.99458 14.5C8.86386 14.5 8.73444 14.4741 8.61378 14.4238C8.49312 14.3736 8.38362 14.2999 8.29158 14.2071Z",
    fill: "#44546F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.e3e55e38fc9b29047c10a7784ef51635.svg";
export { ForwardRef as ReactComponent };